/**
 * @generated SignedSource<<82c37163de0a2445a2a9959a5ecf280e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type DeleteUserInput = {
  clientMutationId?: string | null | undefined;
  id: string;
};
export type UserDetailsDeleteUserMutation$variables = {
  input: DeleteUserInput;
};
export type UserDetailsDeleteUserMutation$data = {
  readonly deleteUser: {
    readonly deletedUserId: string | null | undefined;
  } | null | undefined;
};
export type UserDetailsDeleteUserMutation = {
  response: UserDetailsDeleteUserMutation$data;
  variables: UserDetailsDeleteUserMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "DeleteUserPayload",
    "kind": "LinkedField",
    "name": "deleteUser",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "deletedUserId",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "UserDetailsDeleteUserMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "UserDetailsDeleteUserMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "acc1c338fd04d8cc2dfa0776d80e6231",
    "id": null,
    "metadata": {},
    "name": "UserDetailsDeleteUserMutation",
    "operationKind": "mutation",
    "text": "mutation UserDetailsDeleteUserMutation(\n  $input: DeleteUserInput!\n) {\n  deleteUser(input: $input) {\n    deletedUserId\n  }\n}\n"
  }
};
})();

(node as any).hash = "351ec34272e3095505f3443699de3a00";

export default node;
